module.exports = __webpack_public_path__ + "static/media/Buzzer_Helloween_Andi.8c756e9f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/Buzzer_Helloween_Andi.mp3
// module id = 284
// module chunks = 0